import { generateLegalServiceSchema } from '../../utils/seo';
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import TargetAudience from '../../components/feature/TargetAudience';
import Services from '../../components/feature/Services';
import About from '../../components/feature/About';
import Team from '../../components/feature/Team';
import QualificationForm from '../../components/feature/QualificationForm';
import Contact from '../../components/feature/Contact';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <>
      {generateLegalServiceSchema()}
      <div className="min-h-screen bg-black">
        <Header />
        <main>
          <Hero />
          <TargetAudience />
          <Services />
          <About />
          <Team />
          <QualificationForm />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}
